import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { PORTAL_FEATURES, OVERRIDE, defaultOn } from '../../services/portal/portalFeatures';

const TOGGLE_SX = {
  '& .MuiToggleButton-root': { height: 26, px: 1.25, fontSize: '0.75rem', textTransform: 'none' },
  '& .MuiToggleButton-root.Mui-selected': { bgcolor: 'primary.main', color: 'primary.contrastText', '&:hover': { bgcolor: 'primary.dark' } },
};

/**
 * Add/Edit Client › Portal access: per feature Default (follow the typing center) / On / Off.
 * 14-portal/PORTAL-EMPLOYEES-AND-FEATURES.md §4.2.
 *
 * Props: overrides { KEY: 'ON' | 'OFF' } (absent = Default), onChange(next), defaults (TC defaults),
 *        showThaklisFeatures (Employees + Document Expiry rows: client type under a Thaklis-enabled TC).
 */
const PortalAccessSection = ({ overrides = {}, onChange, defaults = {}, showThaklisFeatures = true, disabled = false, hideTitle = false }) => {
  const features = PORTAL_FEATURES.filter((f) => showThaklisFeatures || !f.thaklisOnly);

  const set = (key, value) => {
    if (!value) return;
    const next = { ...overrides };
    if (value === OVERRIDE.DEFAULT) delete next[key]; else next[key] = value;
    onChange(next);
  };

  return (
    <Box sx={{ mt: hideTitle ? 0 : 2 }}>
      {!hideTitle && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>Portal access</Typography>
        </Box>
      )}
      {!hideTitle && (
        <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', mb: 1 }}>
          Default follows Settings › Client Portal. Choose On or Off to set it for this client only.
        </Typography>
      )}
      <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}>
        {features.map((f, i) => (
          <Box
            key={f.key}
            sx={{
              display: 'flex', alignItems: 'center', gap: 1.5, px: 1.5, py: 0.75, flexWrap: 'wrap',
              borderTop: i > 0 ? 1 : 0, borderColor: 'divider',
            }}
          >
            <Typography sx={{ fontSize: '0.8125rem', flex: '1 1 160px' }}>{f.label}</Typography>
            <ToggleButtonGroup
              exclusive
              size="small"
              disabled={disabled}
              value={overrides[f.key] || OVERRIDE.DEFAULT}
              onChange={(e, v) => set(f.key, v)}
              sx={TOGGLE_SX}
              aria-label={f.label}
            >
              <ToggleButton value={OVERRIDE.DEFAULT}>Default ({defaultOn(defaults, f.key) ? 'on' : 'off'})</ToggleButton>
              <ToggleButton value={OVERRIDE.ON}>On</ToggleButton>
              <ToggleButton value={OVERRIDE.OFF}>Off</ToggleButton>
            </ToggleButtonGroup>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PortalAccessSection;
